import lottie from 'lottie-web/build/player/lottie_light'
import makeLottiePlayer from './makeLottiePlayer'

export default makeLottiePlayer(lottie)
